import React from 'react'
import cn from 'classnames'
import IconFire from 'client/icons/Fire'
import IconRocket from 'client/icons/Rocket'

import styles from './styles.module.css'

const getIcon = (branded: boolean) => {
  if (branded) {
    return <IconRocket size={12} />
  }
  return <IconFire size={12} />
}

const BestPropertyTag = ({ copy, branded = false }: { copy: string; branded?: boolean }) => {
  return (
    <div className={cn(styles.bestPropertyTag, { [styles.branded]: branded })}>
      {getIcon(branded)}
      {copy}
    </div>
  )
}

export default BestPropertyTag
